import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import EventDirectory from "@/modules/eventRegistration/features/EventDirectory/components/EventDirectory/EventDirectory";
import EventDetails from "@/modules/eventRegistration/features/EventDirectory/components/EventDetails/EventDetails";
import SelectAttendees from "@/modules/eventRegistration/features/EventRegistration/components/SelectAttendees/SelectAttendees";
import Checkout from "@/modules/eventRegistration/features/EventRegistration/components/Checkout/Checkout";
import EventRegistrationEntry from "@/modules/eventRegistration/features/EventRegistration/components/EventRegistrationEntry/EventRegistrationEntry";
import Confirmation from "@/modules/eventRegistration/features/EventRegistration/components/Confirmation/Confirmation";

// Create stable component reference
const EventRegistrationMainLayout = () => (
  <MainLayout section="event-registration" />
);

const EventRegistrationRoutes = (
  <Route
    element={<AuthenticationGuard component={EventRegistrationMainLayout} />}
    path="/event-registration"
  >
    {/* Public Event Directory */}
    <Route element={<EventDirectory />} path="events" />
    <Route element={<EventDetails />} path="events/:uuid" />

    {/* Event Registration Flow */}
    <Route
      element={<EventRegistrationEntry />}
      path="events/register/:eventSessionUuid/entry"
    />
    <Route
      element={<SelectAttendees />}
      path="events/register/:eventCheckoutSessionUuid/attendees"
    />
    <Route
      element={<Checkout />}
      path="events/register/:eventCheckoutSessionUuid/checkout"
    />
    <Route
      element={<Confirmation />}
      path="events/register/:eventCheckoutSessionUuid/confirmation"
    />
  </Route>
);

export default EventRegistrationRoutes;
